export default function PlayerRepeatCurrent() {
  return (
    <g
      transform="translate(15.000000,105.000000) scale(0.100000,-0.100000)"
      stroke="none"
    >
      <path
        d="M450 735 l0 -45 -131 0 c-149 0 -183 -10 -226 -67 -33 -43 -45 -136
-19 -146 28 -11 44 3 55 47 20 82 71 106 223 106 l98 0 0 -45 c0 -25 3 -45 6
-45 13 0 204 113 204 120 0 7 -191 120 -204 120 -3 0 -6 -20 -6 -45z"
      />
      <path
        d="M748 759 c-20 -14 -28 -30 -28 -50 0 -34 2 -35 35 -13 l25 16 0 -86
0 -86 30 0 30 0 0 120 0 120 -32 0 c-18 0 -45 -10 -60 -21z"
      />
      <path
        d="M792 421 c-5 -3 -15 -24 -21 -47 -13 -48 -45 -81 -92 -94 -19 -6
-112 -10 -206 -10 l-173 0 0 45 c0 25 -3 45 -6 45 -13 0 -204 -113 -204 -120
0 -7 191 -120 204 -120 3 0 6 20 6 45 l0 45 206 0 c231 0 254 5 301 67 19 24
28 50 31 87 4 47 2 54 -16 58 -11 3 -24 3 -30 -1z"
      />
    </g>
  );
}
